import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CalendlyService } from '../../services/calendly.service';

@Component({
  selector: 'app-side-menu',
  imports: [CommonModule, RouterLink],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss'
})
export class SideMenu {
  constructor(private calendly: CalendlyService) { }

  public isClosing = false;

  dropdownStates: Record<string, { show: boolean; animating: boolean }> = {
    developmentServices: { show: false, animating: false },
    marketingServices: { show: false, animating: false },
    cases: { show: false, animating: false },
  };


  @Output()
  private closeMenu = new EventEmitter<void>();

  hideMenu() {
    this.isClosing = true;
    setTimeout(() => {
      this.closeMenu.emit();
      this.isClosing = false;
    }, 300);
  }

  scheduleCall() {
    this.calendly.openPopup().catch(() => { });
  }

  toggleDropdown(dropdown: 'developmentServices' | 'marketingServices' | 'cases') {
    const state = this.dropdownStates[dropdown];

    if (state.show) {
      state.animating = true;
      state.show = false;

      setTimeout(() => {
        state.animating = false;
      }, 300);
    } else {
      state.show = true;
    }
  }

  onAnimationEnd(dropdown: 'developmentServices' | 'marketingServices' | 'cases') {
    const state = this.dropdownStates[dropdown];
    if (state.animating) {
      state.animating = false;
    }
  }

}
